export const uploadImageToDtf = async (
  imageVersionId: string,
  imageUrl: string,
  productCatalogNumber?: string | null
): Promise<{ redirect_url?: string }> => {
  const imageResponse = await fetch(imageUrl);
  if (!imageResponse.ok) {
    throw new Error(`Failed to download image: ${imageResponse.status}`);
  }

  const imageBlob = await imageResponse.blob();
  const formData = new FormData();
  formData.append("file", imageBlob, "ai-generated-image.png");
  formData.append("generate_link", "true");
  formData.append("ai_image_version_id", imageVersionId);

  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);

  const isMade = urlParams.get("made") === "true";
  const catalogNumber = productCatalogNumber || "3001C";
  if (isMade || !productCatalogNumber) {
    formData.append("is_made", "true");
    formData.append("is_made_flash", "false");
  }

  formData.append("catalog_number", catalogNumber);

  const color = urlParams.get("ac");
  if (color || catalogNumber === "3001C") {
    formData.append("ac", color || "White");
  }

  const sample = urlParams.get("sample");
  if (sample === "true") {
    formData.append("sample", "true");
  }

  let side = urlParams.get("side");
  if (side !== "front" && side !== "back") side = "front";
  formData.append("side", side);

  const uploadResponse = await fetch("/api/users/dtf_artworks", {
    method: "POST",
    body: formData,
    credentials: "include"
  });

  if (!uploadResponse.ok) {
    let error = `Something went wrong. Please try again.`;
    try {
      const json = await uploadResponse.json();
      error = json.error;
    } catch (e) {
      // Do nothing
    }
    throw new Error(error);
  }

  return uploadResponse.json();
};
